import requestAction from '../../utils/requestAction'

export const fetchOrder = (orderId: string, clientId?: string, params?: string) => {  
  if (!params)
    params = 'limit=1000'
  return requestAction('ORDER_DETAIL')(`orders/detail?orderId=${orderId.trimEnd()}${clientId ? '&clientId='+clientId: ''}${params ? '&'+params.replace('?', '') : ''}`, 'GET')
}
